import { render, staticRenderFns } from "./businessLocation.vue?vue&type=template&id=6540e376&"
import script from "./businessLocation.vue?vue&type=script&lang=js&"
export * from "./businessLocation.vue?vue&type=script&lang=js&"
import style0 from "./businessLocation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports